import { gql } from '@apollo/client';

export const GET_ONBOARDING_PRODUCTS = gql`
	query {
		getProductsFromAdmin {
			status
			name
			id
			imageUrl
			dateNextySelection
			nextyFinalist
			nextyWinner
			marketReady
			productCategory
			productDescription
			imagesLastUpdate
			pintoLastUpdates
			pintoStatus
			productApprovalConditions
			approvedOn
			flagshipProduct
			dimensions {
				width {
					inches
					millimeters
				}
				height {
					inches
					millimeters
				}
				depth {
					inches
					millimeters
				}
				weight {
					ounces
					grams
				}
			}
			productMSRP
			launchYear
			productGTIN
			productShelfLife
			certifiedGlutenFree
			certifiedNonGMO
			certifiedOrganic
			showHowGood
			howGoodLabel
			howGoodEstimated
			howGoodAvgEstimated
			howGoodScore
			violations {
				allergenMissing
				botanicPartsMissing
				claimsLogoRequiresCertification
				containsBannedIngredients
				directionsForUse
				ingredientsListMissing
				manufacturerAddressMissing
				misuseFDAApprovedHealthClaim
				organicCertifyingAgentMissing
				statementIdentityMissing
				unclarifiedNutrient
				missingIncorrectNFP
				missingNQC
			}
		}
	}
`;
